import ItemsList from "../../sections/ItemsList/ItemsList";
import OrderForm from "../../sections/OrderForm/OrderForm";
import "./Cart.css";

function Cart() {
  return (
    <main className="Cart">
      <ItemsList />
      <OrderForm />
    </main>
  );
}

export default Cart;
